document.addEventListener('DOMContentLoaded', function () {
  console.log('Warenkorb-Skript geladen');

  // Funktion zum Aktualisieren des Warenkorbs per AJAX
  function updateCart(line, quantity, input) {
    fetch(`/cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Warenkorb erfolgreich aktualisiert:', data);

        // Menge im Input-Feld bleibt synchron
        input.value = quantity;

        // Warenkorbanzeige aktualisieren
        updateCartDisplay();
      })
      .catch(error => {
        console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
      });
  }

  // Funktion zur Aktualisierung der Warenkorbanzeige
  function updateCartDisplay() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Aktualisiere die Warenkorbanzahl in der Navigationsleiste
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count > 0 ? cart.item_count : '0';
        });
      })
      .catch(error => {
        console.error('Fehler beim Abrufen der Warenkorbdaten:', error);
      });
  }

  // Event-Listener für Minus-Buttons
  document.querySelectorAll('.qty-minus').forEach(button => {
    button.addEventListener('click', function () {
      const input = this.nextElementSibling; // Nächstes Element (Eingabefeld)
      const currentValue = parseInt(input.value, 10);
      const line = this.closest('.cart-quantity-controls').querySelector('.cart-remove-button').href.split('line=')[1].split('&')[0];

      if (currentValue > 1) {
        input.value = currentValue - 1; // Lokale Aktualisierung
        updateCart(line, currentValue - 1, input);
      }
    });
  });

  // Event-Listener für Plus-Buttons
  document.querySelectorAll('.qty-plus').forEach(button => {
    button.addEventListener('click', function () {
      const input = this.previousElementSibling; // Vorheriges Element (Eingabefeld)
      const currentValue = parseInt(input.value, 10);
      const line = this.closest('.cart-quantity-controls').querySelector('.cart-remove-button').href.split('line=')[1].split('&')[0];

      input.value = currentValue + 1; // Lokale Aktualisierung
      updateCart(line, currentValue + 1, input);
    });
  });

  // Initiale Aktualisierung der Warenkorbanzeige
  updateCartDisplay();
});
